import { Box } from '@chakra-ui/react';

export const FilterItem = ({ item = {}, children, onSelect = () => {} }) => {
  return (
    <Box
      p="8px 20px"
      _hover={{ bg: 'secondary-50', fontWeight: 500 }}
      cursor="pointer"
      fontSize="14px"
      data-test-id={`blueprint-filter-${item?.value}`}
      onClick={() => {
        onSelect(item);
      }}
    >
      {children}
    </Box>
  );
};
